import {Component} from "react";
import HttpRequest from "../../../HttpRequest";
import Loader from "../../../components/Loader";
import ErrorPage from "../../../components/ErrorPage";
import Route from "../../../Route";
import {Tools} from "../../../Tools";



class Dashboard extends Component{
    constructor(props){
        super(props);

        this.httpClient = new HttpRequest();
        this.state = {
            server: {},
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            dashboard: props.dashboard ? props.dashboard : [],
        };
    }


    handlerDashboardChange(dashboard){
        if(this.props.onDashboardChange){
            this.props.onDashboardChange(dashboard);
        }
    }

    render() {

        let element = <h3 className="">Tableau de bord</h3>
        if(!this.state.isLoadCompleted){
            element = <Loader />;
        }
        else if(this.state.hasError){
            const text = this.state.server && this.state.server.message ? "<h1>"+ this.state.server.message +"</h1>" : "";
            element = <ErrorPage data={{content: text}} />;
        }
        else{
            if(!Tools.IsEmpty(this.state.dashboard)){
                element = (
                    <div className=" admin-font-size">
                        <div className="row dashboard">
                            <div className="col-md-4">
                                <div className="dashboard-card">
                                    <span className="mb-3">Demande(s) d'adhésion enrégistrée(s)</span>
                                    <br/>
                                    <br/>
                                    <span>{this.state.dashboard.membersCount}</span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="dashboard-card">
                                    <span className="mb-3">Demande(s) d'adhésion en attente</span>
                                    <br/>
                                    <br/>
                                    <span>{this.state.dashboard.applicationsCount}</span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="dashboard-card">
                                    <span className="mb-3">Demande(s) d'adhésion validée(s)</span>
                                    <br/>
                                    <br/>
                                    <span>{this.state.dashboard.membersValidCount}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return element;
    }


    componentDidMount() {
        this.loadDashboard();
    }

    componentWillUnmount() {
        this.httpClient.cancelRequest();
    }

    loadDashboard() {
        const _self = this;
        if(!Tools.IsEmpty(this.props.dashboard) && Tools.JsonToString(this.props.dashboard) !== Tools.JsonToString(this.state.dashboard)){
            _self.setState({
                hasError: false,
                isLoadCompleted: true,
                dashboard: this.props.dashboard
            });
            return;
        }
        DashboardService().then(function (response){
            _self.server = response.server;
            _self.handlerDashboardChange(response.data.dashboard ? response.data.dashboard : null);
            _self.setState(response.data);
        }).catch(function (response){
            _self.server = response.server;
            _self.setState(response.data);
        });
    }
}

export const DashboardService = () => {
    return (new HttpRequest()).request(Route.APIMembersDashboard, "GET").then(function (response){
        let data = {server: response, isLoadCompleted: true, hasError: true};
        if(response.code === 200){
            data = {
                hasError: false,
                isLoadCompleted: true,
                dashboard: response.data.dashboard,
            };
        }
        return {
            server: response,
            data: data,
        };
    }).catch(function (error){
        return {
            server: error,
            data: {server: error, hasError: true },
        };
    });
}

export default Dashboard;